import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { NzCarouselComponent, NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgForOf } from '@angular/common';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

import { GalleryMedia } from '../gallery';

@Component({
  selector: 'app-carousel-modal',
  templateUrl: './carousel-modal.component.html',
  styleUrls: ['./carousel-modal.component.less'],
  imports: [NzCarouselModule, NzIconModule, NgForOf],
  standalone: true
})
export class CarouselModalComponent implements OnInit {
  @ViewChild(NzCarouselComponent, { static: true })
  public carousel!: NzCarouselComponent;
  @Input() public images: GalleryMedia[] = [];
  @Input() public selectedImage?: string;

  private modalData = inject(NZ_MODAL_DATA);

  public ngOnInit() {
    const index = this.selectedImage ? this.images.findIndex((i) => i.src === this.selectedImage) : null;

    if (index && index >= 0) {
      setTimeout(() => this.carousel.goTo(index));
    }

    this.images = this.modalData.images;
    this.selectedImage = this.modalData.selectedImage;
  }

  public goToPrev() {
    this.carousel.pre();
  }

  public goToNext() {
    this.carousel.next();
  }
}
